//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "secondary_page_title",
  data () {
    return {
      show_back: true
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    goHome () {
      this.$router.push({ name: 'union' })
    },
    goBack () {
      if (window.history.length <= 1) {
        this.$router.push({ name: 'union' })
      } else {
        if (this.$route.name == 'home' || this.$route.name == 'live' || this.$route.name == 'play' || this.$route.name == 'video_detail') {
          this.$router.go(-1)
        } else if (this.$route.name == 'luck-draw') {
          if (this.$route.params.target_type) {
            //首页跳转至转盘页
            let _this = this
            setTimeout(function () {
              if (_this.$route.params.target_type == 1) {
                _this.$router.replace({ name: 'home', params: { id: _this.$route.params.id } })
              } else if (_this.$route.params.target_type == 2) {
                _this.$router.replace({ name: 'live', params: { live_id: _this.$route.params.id } })
              } else if (_this.$route.params.target_type == 3) {
                _this.$router.replace({ name: 'play', params: { live_id: _this.$route.params.id } })
              } else if (_this.$route.params.target_type == 4) {
                _this.$router.replace({
                  name: 'video_detail',
                  params: { id: _this.$route.params.id, exa_id: _this.$route.params.exa_id }
                })
              } else if (_this.$route.params.target_type == 5) {
                _this.$router.replace({ name: 'ordinary-user' })
              } else if (_this.$route.params.target_type == 6) {
                _this.$router.replace({ name: 'collections' })
              } else if (_this.$route.params.target_type == 7) {
                _this.$router.replace({ name: 'union' })
              } else if (_this.$route.params.target_type == 8) {
                _this.$router.replace({ name: 'order-detail', params: { id: _this.$route.params.id } })
              }
            }, 1500);
          } else {
            //支付页面跳转至转盘页
            this.$router.go(-1)
          }
        } else if(this.$route.name == 'log') {
          this.$router.push({ name: 'manager_index' })
        } else {
          this.$router.go(-1)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/secondary_page_title.vue